/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  mouseover(e) {
    const el = e.currentTarget;
    el.querySelector('a.nav-link').classList.add('menu-active');
    el.querySelector('.dropdown-menu').style.display = 'block';
  }

  mouseout(e) {
    const el = e.currentTarget;
    el.querySelector('a.nav-link').classList.remove('menu-active');
    el.querySelector('.dropdown-menu').style.display = 'none';
  }

  beforeCache() {
    this.element.querySelectorAll('.nav-item.dropdown .dropdown-menu').forEach((el) => el.style.display = 'none');
    this.element.querySelectorAll('.nav-item.dropdown a.nav-link').forEach((el) => el.classList.remove('menu-active'));
  }
}
